export default {
  drawerHeight: '50vh',
  google: {
    mapOptions: {
      center: { lat: 39.1659, lng: -84.5374 },
      zoom: 11,
      gestureHandling: 'greedy',
    },
    GOOGLE_MAPS_API_KEY: 'AIzaSyC8iZJ7fkZCd9kNjPAhgz9bTsSbwNVcOzw',
    GOOGLE_MAP_ID: 'e0893ed5a0003374',
  },
  groups: {
    n: {
      source: '/data/neighborhoods.geojson',
    },
    bg: {
      source: '/data/blockgroups.geojson',
    },
  },
  layers: [
    {
      id: 'ntc2020',
      name: '2020 Tree Canopy',
      group: 'n',
      colors: [[255, 255, 255], [0, 88, 36]],
      min: {
        value: 0,
        label: '0%',
        labelColor: 'rgba(0, 0, 0, 0.5)',
      },
      max: {
        value: 100,
        label: '100%',
        labelColor: 'rgba(255, 255, 255, 0.5)',
      },
      valueUnits: '%',
      show: false,
      opacity: 0.75,
      weight: 0,
      description: 'The percent of tree canopy relative to total land area in each neighborhood in 2020.',
    },
    {
      id: 'ntc2011',
      name: '2011 Tree Canopy',
      group: 'n',
      colors: [[255, 255, 255], [0, 88, 36]],
      min: {
        value: 0,
        label: '0%',
        labelColor: 'rgba(0, 0, 0, 0.5)',
      },
      max: {
        value: 100,
        label: '100%',
        labelColor: 'rgba(255, 255, 255, 0.5)',
      },
      valueUnits: '%',
      show: false,
      opacity: 0.75,
      weight: 0,
      description: 'The percent of tree canopy relative to total land area in each neighborhood in 2011.',
    },
    {
      id: 'ntcc',
      name: 'Tree Canopy Change',
      group: 'n',
      colors: [[179, 0, 0], [255, 255, 255], [1, 108, 89]],
      min: {
        value: -20,
        label: '-20%',
        labelColor: 'rgba(255, 255, 255, 0.5)',
      },
      max: {
        value: 20,
        label: '20%',
        labelColor: 'rgba(255, 255, 255, 0.5)',
      },
      valueUnits: '%',
      show: false,
      opacity: 0.75,
      weight: 0,
      description: 'The percent of change in tree canopy between 2011 and 2020 in each neighborhood. A negative value indicates loss of tree canopy while a positive indicates gain.',
    },
    {
      id: 'etc',
      name: 'Existing Tree Canopy',
      group: 'bg',
      colors: [[255, 255, 255], [0, 88, 36]],
      min: {
        value: 0,
        label: '0%',
        labelColor: 'rgba(0, 0, 0, 0.5)',
      },
      max: {
        value: 100,
        label: '100%',
        labelColor: 'rgba(255, 255, 255, 0.5)',
      },
      valueUnits: '%',
      show: true,
      opacity: 0.75,
      weight: 0,
      description: 'The percent of tree canopy relative to total land area in each block group.',
    },
    {
      id: 'tcc',
      name: 'Tree Canopy Change',
      group: 'bg',
      colors: [[179, 0, 0], [255, 255, 255], [1, 108, 89]],
      min: {
        value: -60,
        label: '-60%',
        labelColor: 'rgba(255, 255, 255, 0.5)',
      },
      max: {
        value: 60,
        label: '60%',
        labelColor: 'rgba(255, 255, 255, 0.5)',
      },
      valueUnits: '%',
      show: false,
      opacity: 0.75,
      weight: 0,
      description: 'The percent of change in tree canopy between 2011 and 2020 in each block group. A negative value indicates loss of tree canopy while a positive indicates gain.',
    },
    {
      id: 'ptc',
      name: 'Possible Tree Canopy',
      group: 'bg',
      colors: [[255, 255, 255], [28, 144, 153]],
      min: {
        value: 0,
        label: '0%',
        labelColor: 'rgba(0, 0, 0, 0.5)',
      },
      max: {
        value: 100,
        label: '100%',
        labelColor: 'rgba(255, 255, 255, 0.5)',
      },
      valueUnits: '%',
      show: false,
      opacity: 0.75,
      weight: 0,
      description: 'The percent of land available for new tree canopy relative to total land area in each block group',
    },
    {
      id: 'ap',
      name: 'Air Pollution (PM 2.5)',
      group: 'bg',
      colors: [[166, 54, 3], [255, 255, 255]],
      min: {
        value: 8.7,
        label: 'high',
        labelColor: 'rgba(255, 255, 255, 0.5)',
      },
      max: {
        value: 8.3,
        label: 'low',
        labelColor: 'rgba(0, 0, 0, 0.5)',
      },
      valueUnits: ' μg/m^3',
      show: false,
      opacity: 0.75,
      weight: 0,
      description: 'The total amount of fine particulate matter in the air.',
    },
    {
      id: 'srr',
      name: 'Stormwater Retention',
      group: 'bg',
      colors: [[4, 90, 141], [255, 255, 255]],
      min: {
        value: 0,
        label: 'low',
        labelColor: 'rgba(255, 255, 255, 0.5)',
      },
      max: {
        value: 0.2,
        label: 'high',
        labelColor: 'rgba(0, 0, 0, 0.5)',
      },
      valueUnits: '',
      show: false,
      opacity: 0.75,
      weight: 0,
      description: 'The capacity of existing vegetation to retain surface water runoff.',
    },
    {
      id: 'him',
      name: 'Heat Island Mitigation',
      group: 'bg',
      colors: [[179, 0, 0], [255, 255, 255]],
      min: {
        value: 0,
        label: 'low',
        labelColor: 'rgba(255, 255, 255, 0.5)',
      },
      max: {
        value: 1,
        label: 'high',
        labelColor: 'rgba(0, 0, 0, 0.5)',
      },
      valueUnits: '',
      show: false,
      opacity: 0.75,
      weight: 0,
      description: 'The capacity of existing vegetation to cool local temperatures through heat absorption.',
    },
    {
      id: 'tcirb',
      name: 'Tree Canopy Relative to Black Residents',
      group: 'bg',
      colors: [[179, 0, 0], [255, 255, 255], [110, 1, 107]],
      min: {
        value: 1,
        label: 'less',
        labelColor: 'rgba(255, 255, 255, 0.5)',
      },
      max: {
        value: -1,
        label: 'more',
        labelColor: 'rgba(255, 255, 255, 0.5)',
      },
      valueUnits: '',
      show: false,
      opacity: 0.75,
      weight: 0,
      description: 'The difference between the proportion of population that is Black and the proportion of canopy cover in a given block group. A negative value indicates that there is a large proportion of canopy cover relative to the proportion of the population that is Black, while a positive value indicates that there is little canopy cover relative to the proportion of the population that is Black.',
    },
    {
      id: 'tcirh',
      name: 'Tree Canopy Relative to Hispanic Residents',
      group: 'bg',
      colors: [[179, 0, 0], [255, 255, 255], [110, 1, 107]],
      min: {
        value: 1,
        label: 'less',
        labelColor: 'rgba(255, 255, 255, 0.5)',
      },
      max: {
        value: -1,
        label: 'more',
        labelColor: 'rgba(255, 255, 255, 0.5)',
      },
      valueUnits: '',
      show: false,
      opacity: 0.75,
      weight: 0,
      description: 'The difference between the proportion of population that is Hispanic and the proportion of canopy cover in a given block group. A negative value indicates that there is a large proportion of canopy cover relative to the proportion of the population that is Hispanic, while a positive value indicates that there is little canopy cover relative to the proportion of the population that is Hispanic.',
    },
    {
      id: 'tcii',
      name: 'Tree Canopy Relative to Residents Living in Poverty',
      group: 'bg',
      colors: [[179, 0, 0], [255, 255, 255], [110, 1, 107]],
      min: {
        value: 1,
        label: 'less',
        labelColor: 'rgba(255, 255, 255, 0.5)',
      },
      max: {
        value: -1,
        label: 'more',
        labelColor: 'rgba(255, 255, 255, 0.5)',
      },
      valueUnits: '',
      show: false,
      opacity: 0.75,
      weight: 0,
      description: 'The difference between the proportion of population that lives below the national poverty line and the proportion of canopy cover in a given block group. A negative value indicates that there is a large proportion of canopy cover relative to the proportion of the population that lives below the poverty line, while a positive value indicates that there is little canopy cover relative to the proportion of the population that lives below the poverty line.',
    },
  ],
  plan: {
    colors: [[255, 255, 255], [0, 100, 88]],
    opacity: 0.75,
  },
};
